module.exports = new Promise((resolve, reject) => {
  const cat = (window.__FEDERACAO__ && window.__FEDERACAO__.remotes) || {}
  const item = cat["core_sdk"]
  if (!item) return reject(new Error('remote "core_sdk" não está no catálogo (window.__FEDERACAO__.remotes)'))
  const pronto = () => {
    const c = window["core_sdk"]
    if (!c) return reject(new Error('o script de "core_sdk" carregou mas não registrou o container'))
    resolve({ get: (m) => c.get(m), init: (s) => { try { return c.init(s) } catch (e) { /* já iniciado */ } } })
  }
  if (window["core_sdk"]) return pronto()
  const el = document.createElement('script'); el.src = item.url; el.async = true
  el.onload = pronto; el.onerror = () => reject(new Error('falha ao carregar ' + item.url))
  document.head.appendChild(el)
});